/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2020 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * UserRoleStyled tab
 *
 * @file UserRoleStyledTab.jsx
 * @author Srinivasan Bakthavatchalam
 * @since 1.0.0
 */

import { withStyles } from '@material-ui/core/styles';
import Tab from '@material-ui/core/Tab';

const UserRoleStyledTab = withStyles({
  root: {
    margin: 0
  },
  textColorPrimary: {
    color: 'inherit !important',
    fontFamily: 'TT Commons',
    fontSize: 20
  },
  disabled: {
    color: '#9BA1AD !important'
  },
  selected: {
    color: 'inherit !important'
  }
})(Tab);

export default UserRoleStyledTab;
